import Vue from 'vue'
import Router from 'vue-router'
import Historical from '../components/Historical.vue'
import Comparison from '../components/Comparison.vue'
import Appliances from '../components/Appliances.vue'
import Substations from '../components/Substations.vue'
import ElectricVehicles from '../components/ElectricVehicles.vue'
import Samples from '../components/Samples.vue'
import Login from '../components/Login.vue'
import Page from '../Page.vue'
import Home from '../components/Home.vue'
import store from '../store'
import i18n from '../lang/i18n.js'
import Settings from '../components/Settings.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ResetPassword from '../components/ResetPassword.vue'

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'Page',
        component: Page,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'Recent',
                component: Home,
                meta: {
                    name_to_translate: 'more_recent',
                    title: "shift2dc | "+i18n.t('more_recent'),
                    authorize: ['SuperAdmin', 'Admin', 'UPAC']
                }
            },
            {
                path: 'historical',
                name: 'Historical',
                component: Historical,
                meta: {
                    name_to_translate: 'historical',
                    title: "shift2dc | "+i18n.t('historical'),
                    authorize: ['SuperAdmin', 'Admin', 'UPAC']
                }
            },
            {
                path: 'comparison',
                name: 'Comparison',
                component: Comparison,
                meta: {
                    name_to_translate: 'comparison',
                    title: "shift2dc | "+i18n.t('comparison'),
                    authorize: ['SuperAdmin', 'Admin', 'UPAC']
                }
            },
            {
                path: 'appliances',
                name: 'Appliances',
                component: Appliances,
                meta: {
                    name_to_translate: 'appliances',
                    title: "shift2dc | "+i18n.t('appliances'),
                    authorize: ['SuperAdmin', 'Admin', 'Appliances']
                }
            },
            {
                path: 'transformation-stations',
                name: 'Substations',
                component: Substations,
                meta: {
                    name_to_translate: 'transformation_stations',
                    title: "shift2dc | "+i18n.t('transformation_stations'),
                    authorize: ['SuperAdmin', 'Admin', 'Substations']
                }
            },
            {
                path: 'ev',
                name: 'EV',
                component: ElectricVehicles,
                meta: {
                    name_to_translate: 'electric_vehicles',
                    title: "shift2dc | "+i18n.t('electric_vehicles'),
                    authorize: ['SuperAdmin', 'Admin', 'EV']
                }
            },
            {
                path: 'samples',
                name: 'Samples',
                component: Samples,
                meta: {
                    title: "shift2dc | Samples",
                    requiresAdmin: true,
                    authorize: ['SuperAdmin', 'Admin']
                }
            },
            {
                path: 'settings',
                name: 'Settings',
                component: Settings,
                meta: {
                    name_to_translate: 'Change_password',
                    title: "shift2dc | "+i18n.t('Change_password'),
                    //authorize: ['SuperAdmin', 'Admin', 'UPAC', 'Appliances', 'EV']
                }
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        props: true,
        meta: {
            name_to_translate: 'Login',
            title: "shift2dc | "+i18n.t('Login')
        }
    },
    {
        path: '/forgot',
        name: 'ForgotPassword',
        component: ForgotPassword,
        props: true,
        meta: {
            name_to_translate: 'Forgot_password',
            title: "shift2dc | "+i18n.t('Forgot_password')
        }
    },
    {
        path: '/reset/:token',
        name: 'ResetPassword',
        component: ResetPassword,
        props: true,
        meta: {
            name_to_translate: 'Reset_password',
            title: "shift2dc | "+i18n.t('Reset_password')
        }
    },
    {
        path: '*',
        redirect: '/'
    }
];

const router = new Router({
    linkExactActiveClass: 'active',
    routes: routes
})

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAdmin)){
        if (store.getters.isLoggedIn && store.getters.user_isAdmin) {
            next()
            return
        }
    }
    else if(to.matched.some(record => record.meta.requiresAuth)) {
        /* if (store.getters.isLoggedIn) {
            next()
            return
        }
        next('/login')  */
        
        if (store.getters.isLoggedIn){
            if (to.matched.some(record => record.meta.authorize)){
                const authorize = to.meta.authorize
                const user_roles = store.getters.user_roles

                for (let role of user_roles){
                    if (authorize.includes(role)) return next()
                }
                if (to.path == '/'){ 
                    if (user_roles.includes('Appliances')) {
                        return next('/appliances')
                    }
                    else if (user_roles.includes('EV')) {
                        return next('/ev')
                    }
                    else if (user_roles.includes('Substations')) {
                        return next('/substations')
                    }
                }
                return next('/')  
            }
            return next()
        }
        return next('/login')
    } 
    else {
        if ((to.name == "ForgotPassword" || to.name == "ResetPassword") && store.getters.isLoggedIn)
            return next('/')

        return next() 
    }
})

router.afterEach((to, from) => {
    store.commit('clear_data')
    store.commit('clear_current_data')
    store.commit('clear_selection')
    if (store.getters.isLoggedIn)
        $.getJSON('/api/tracking?user='+store.getters.username+'&path='+window.location.pathname)
    Vue.nextTick( () => {
        $('[data-toggle="tooltip"]').tooltip() 
        to.meta.title =  to.meta.name_to_translate ? "shift2dc | "+i18n.t(to.meta.name_to_translate) : to.meta.title
        document.title = to.meta.title ? to.meta.title : 'shift2dc';
    });
})

export default router;